import React from "react";
import {
  UserGroupIcon,
  UserIcon,
  PlusCircleIcon,
  ClipboardDocumentCheckIcon,
  ChartBarIcon,
  InboxStackIcon,
  ArrowTrendingUpIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/24/outline";

export default function SupportTeams() {
  return (
    <div
      className="min-h-screen bg-gray-100 px-4 py-6 md:px-10"
      style={{ fontFamily: "Poppins, Roboto, sans-serif" }}
    >
      {/* PAGE HEADER */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Support Teams</h1>
          <p className="text-gray-600 text-sm mt-1">
            Manage support agents, responsibilities, SLAs and workload.
          </p>
        </div>

        {/* ADD TEAM BUTTON */}
        <button className="px-4 py-2 bg-indigo-600 text-white rounded-lg shadow hover:bg-indigo-700 flex items-center">
          <PlusCircleIcon className="h-5 w-5 mr-2" />
          Add New Team
        </button>
      </div>

      {/* TOP STATISTICS SECTION */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-10">

        <StatsCard
          title="Total Support Agents"
          value="42"
          icon={UserGroupIcon}
          color="bg-blue-600"
        />

        <StatsCard
          title="Active Today"
          value="29"
          icon={UserIcon}
          color="bg-green-600"
        />

        <StatsCard
          title="Tickets Assigned Today"
          value="134"
          icon={InboxStackIcon}
          color="bg-yellow-500"
        />

        <StatsCard
          title="SLA Achievement"
          value="96%"
          icon={ArrowTrendingUpIcon}
          color="bg-purple-600"
        />

      </div>

      {/* TEAMS LIST SECTION */}
      <div className="bg-white rounded-xl shadow p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Support Teams Directory</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">

          <TeamCard
            name="L1 Support Team"
            members="12 Agents"
            desc="Handles basic queries, login issues, password resets."
          />

          <TeamCard
            name="L2 Support Team"
            members="9 Agents"
            desc="Handles technical issues, escalations, module failures."
          />

          <TeamCard
            name="L3 Technical Support"
            members="6 Engineers"
            desc="Product bugs, API issues, backend malfunction."
          />

          <TeamCard
            name="HR Support Team"
            members="5 Agents"
            desc="HR queries, payroll issues, attendance disputes."
          />

          <TeamCard
            name="IT Helpdesk Team"
            members="10 Agents"
            desc="Laptop issues, VPN, email, onboarding system help."
          />

        </div>
      </div>
    </div>
  );
}

/* ----------------------------------------
    STATS CARD COMPONENT
----------------------------------------- */
const StatsCard = ({ title, value, icon: Icon, color }) => (
  <div className="bg-white rounded-xl shadow p-5 flex items-center justify-between hover:shadow-xl transition cursor-pointer">
    <div>
      <p className="text-gray-500 text-sm">{title}</p>
      <h2 className="text-2xl font-bold mt-1">{value}</h2>
    </div>
    <div className={`${color} p-3 rounded-lg`}>
      <Icon className="h-7 w-7 text-white" />
    </div>
  </div>
);

/* ----------------------------------------
    TEAM CARD COMPONENT
----------------------------------------- */
const TeamCard = ({ name, members, desc }) => (
  <div className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg transition cursor-pointer">
    <div className="flex justify-between items-start">
      <div>
        <h3 className="text-xl font-semibold text-gray-800">{name}</h3>
        <p className="text-gray-500 text-sm">{members}</p>
      </div>

      <EllipsisHorizontalIcon className="h-6 w-6 text-gray-400" />
    </div>

    <p className="mt-3 text-gray-600 text-sm leading-relaxed">{desc}</p>

    <button className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm hover:bg-indigo-700 flex items-center">
      <ClipboardDocumentCheckIcon className="h-4 w-4 mr-2" />
      View Details
    </button>
  </div>
);
